export default __webpack_public_path__ + "static/media/img-discount-depreciated.97bc6afb.png";